import { createContext } from 'react'

/**
 * True inside a record page whose frame already put the one gap between the
 * tab bar and the tab's content (PageContainer `isRecord`). Chrome that leads
 * a tab and normally brings its own top padding — the Settings-style side
 * menu, the record canvas — reads it and starts flush, so every tab of every
 * record starts the same distance under the tabs.
 */
export const RecordTabGapContext = createContext(false)
